import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentList_YiSpecialTagsByTitlesQueryVariables = Types.Exact<{
  titles?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
  contentPolicyPolicyId: Types.Scalars['Int']['input']
}>

export type ContentList_YiSpecialTagsByTitlesQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      language?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export const ContentList_YiSpecialTagsByTitlesDocument = gql`
  query ContentList_YISpecialTagsByTitles($titles: [String!] = [], $contentPolicyPolicyId: Int!) {
    contentList(
      where: {
        contentType: { eq: "tag" }
        title: { in: $titles }
        contentPolicyPolicyId: { eq: $contentPolicyPolicyId }
      }
      referencesNot: [{ type: "yi-content-type", contentType: "tag" }]
    ) {
      content {
        id
        language
        title
        contentId
        contentType
        published
        contentProvider {
          ...Content_ProviderCommonFragment
          providerKey
        }
      }
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`

/**
 * __useContentList_YiSpecialTagsByTitlesQuery__
 *
 * To run a query within a React component, call `useContentList_YiSpecialTagsByTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentList_YiSpecialTagsByTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentList_YiSpecialTagsByTitlesQuery({
 *   variables: {
 *      titles: // value for 'titles'
 *      contentPolicyPolicyId: // value for 'contentPolicyPolicyId'
 *   },
 * });
 */
export function useContentList_YiSpecialTagsByTitlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  > &
    (
      | { variables: ContentList_YiSpecialTagsByTitlesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  >(ContentList_YiSpecialTagsByTitlesDocument, options)
}
export function useContentList_YiSpecialTagsByTitlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  >(ContentList_YiSpecialTagsByTitlesDocument, options)
}
// @ts-ignore
export function useContentList_YiSpecialTagsByTitlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ContentList_YiSpecialTagsByTitlesQuery,
  ContentList_YiSpecialTagsByTitlesQueryVariables
>
export function useContentList_YiSpecialTagsByTitlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_YiSpecialTagsByTitlesQuery,
        ContentList_YiSpecialTagsByTitlesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ContentList_YiSpecialTagsByTitlesQuery | undefined,
  ContentList_YiSpecialTagsByTitlesQueryVariables
>
export function useContentList_YiSpecialTagsByTitlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_YiSpecialTagsByTitlesQuery,
        ContentList_YiSpecialTagsByTitlesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContentList_YiSpecialTagsByTitlesQuery,
    ContentList_YiSpecialTagsByTitlesQueryVariables
  >(ContentList_YiSpecialTagsByTitlesDocument, options)
}
export type ContentList_YiSpecialTagsByTitlesQueryHookResult = ReturnType<
  typeof useContentList_YiSpecialTagsByTitlesQuery
>
export type ContentList_YiSpecialTagsByTitlesLazyQueryHookResult = ReturnType<
  typeof useContentList_YiSpecialTagsByTitlesLazyQuery
>
export type ContentList_YiSpecialTagsByTitlesSuspenseQueryHookResult = ReturnType<
  typeof useContentList_YiSpecialTagsByTitlesSuspenseQuery
>
export type ContentList_YiSpecialTagsByTitlesQueryResult = Apollo.QueryResult<
  ContentList_YiSpecialTagsByTitlesQuery,
  ContentList_YiSpecialTagsByTitlesQueryVariables
>
